export enum TypeMessageTape {
  DEFAULT = 'default',
  LOCALHOST_ENVIRONMENT = 'localhost-environment',
  DEVELOPMENT_ENVIRONMENT = 'development-environment',
  HOMOLOGATION_ENVIRONMENT = 'homologation-environment',
  SYSTEM_ALERT = 'system-alert',
  SOCKET_INTERRUPTED = 'socket-interrupted'
}
